import { MUIView } from "./MUIView";


export class MUIOutlineView extends MUIView 
{

}